<template>
  <div class="ui-step-card">
    <div class="ui-step-card__icon">{{ icon }}</div>
    <span class="ui-step-card__num">PASSO {{ formattedNum }}</span>
    <h3 class="ui-step-card__title">{{ title }}</h3>
    <p class="ui-step-card__desc">{{ description }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  num: {
    type: [String, Number],
    required: true,
  },
  icon: {
    type: String,
    default: '💡',
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
});

const formattedNum = computed(() => String(props.num).padStart(2, '0'));
</script>

<style scoped>
.ui-step-card {
  display: flex;
  flex-direction: column;
  gap: var(--gap-md);
  background: var(--navy-card);
  padding: 40px 32px;
  transition: background 0.25s;
}

.ui-step-card:hover {
  background: var(--navy-mid);
}

.ui-step-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: var(--r-md);
  background: var(--cyan-glow);
  border: 1px solid var(--cyan-glow);
  font-size: 22px;
}

.ui-step-card__num {
  font-family: var(--font-brand);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.15em;
  color: var(--cyan);
}

.ui-step-card__title {
  font-family: var(--font-brand);
  font-size: 18px;
  font-weight: 700;
  color: var(--white);
}

.ui-step-card__desc {
  font-family: var(--font-brand);
  font-size: 14px;
  line-height: 1.65;
  color: var(--muted);
}
</style>
